import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";

class InstallationTemplateRestClient extends RestClient {
  async createInstallationFromTemplate(projectId, form) {
    const url = `${this.path}/create-from-template/`;
    const payload = {
      uuid: form.templateUuid,
      name: form.name,
      project_uuid: projectId,
    };
    if (form.sampleBaseName) {
      payload.sample_base_name = form.sampleBaseName;
    }
    const response = await this.client.post(url, payload);
    return this.toCamel(response.data);
  }

  async createInstallationTemplate(installation) {
    const url = `${this.path}/create-template/`;
    const response = await this.client.post(url, {
      uuid: installation.uuid,
      name: installation.name,
    });
    return this.toCamel(response.data);
  }
}

export const installationTemplateRestClient =
  new InstallationTemplateRestClient(atmoClient, "installationtemplates");
